import React, { useState, useEffect } from 'react';
import axios, { API_URL } from '../api/axiosConfig';

const DetalleSoatModal = ({ isOpen, tramiteId, onClose }) => {
  const [tramite, setTramite] = useState(null);
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen && tramiteId) {
      fetchDetalle();
    }
  }, [isOpen, tramiteId]);

  const fetchDetalle = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get(`/api/tramites/${tramiteId}`);
      setTramite(res.data);
      setArchivos(res.data.archivos || []);
    } catch (err) {
      console.error('Error al cargar detalle para SOAT:', err);
      setError('Error al consultar la información del trámite');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '850px', width: '95%', maxHeight: '90vh', overflowY: 'auto', padding: '0', borderRadius: '16px' }}>
        {/* Encabezado */}
        <div className="modal-header" style={{ padding: '20px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: '0', zIndex: '10' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <h3 style={{ margin: 0, fontSize: '18px', color: '#0f172a' }}>👁️ Detalle de Solicitud #{tramiteId}</h3>
            {tramite?.placa_referencia && (
              <span style={{ background: '#fef08a', color: '#854d0e', padding: '4px 10px', borderRadius: '6px', fontWeight: '800', fontSize: '13px' }}>
                {tramite.placa_referencia}
              </span>
            )}
          </div>
          <button className="close-btn" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#64748b', cursor: 'pointer' }}>
            &times;
          </button>
        </div>

        <div style={{ padding: '24px' }}>
          {loading ? (
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <div className="spinner"></div>
              <p style={{ marginTop: '10px', color: '#64748b' }}>Cargando información del trámite...</p>
            </div>
          ) : error ? (
            <div className="error-banner">{error}</div>
          ) : tramite ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              {/* Columna Izquierda: Información del Propietario y Vehículo */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Card Propietario */}
                <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    👤 Información del Propietario
                  </h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px', color: '#334155' }}>
                    <p style={{ margin: 0 }}><strong>Nombre / Razon Social:</strong> {tramite.datos_adicionales?.propietario || 'No especificado'}</p>
                    <p style={{ margin: 0 }}><strong>Documento / NIT:</strong> {tramite.datos_adicionales?.tipo_documento || 'CC'} {tramite.datos_adicionales?.documento || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Organismo de Tránsito:</strong> {tramite.transito_name || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Fecha Solicitud:</strong> {new Date(tramite.created_at).toLocaleString('es-CO')}</p>
                  </div>
                </div>

                {/* Card Vehículo */}
                <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    🚗 Información Técnica del Vehículo
                  </h4>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px', color: '#334155' }}>
                    <p style={{ margin: 0 }}><strong>Marca:</strong> {tramite.datos_adicionales?.marca || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.marca || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Línea:</strong> {tramite.datos_adicionales?.linea || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.linea || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Modelo:</strong> {tramite.datos_adicionales?.modelo || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.modelo || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Cilindraje (cc):</strong> {tramite.datos_adicionales?.cilindraje || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.datos_completos?.rna?.datos?.cilindraje || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Color:</strong> {tramite.datos_adicionales?.color || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.color || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Motor:</strong> {tramite.datos_adicionales?.motor || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.nro_motor || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>Chasis:</strong> {tramite.datos_adicionales?.chasis || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.nro_chasis || 'N/A'}</p>
                    <p style={{ margin: 0 }}><strong>VIN:</strong> {tramite.datos_adicionales?.vin || tramite.datos_adicionales?.vehicleDetails?.vehiculo?.nro_vin || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Columna Derecha: Documentos Adjuntos */}
              <div>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  📂 Documentos Adjuntos
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {(() => {
                    const allowedTypes = ['factura', 'cedula', 'manifiesto', 'declaracion_importacion', 'declaracion'];
                    const docsFiltrados = (archivos || []).filter(arc => {
                      const t = (arc.tipo_documento || '').toLowerCase();
                      return allowedTypes.some(allowed => t.includes(allowed));
                    });

                    if (docsFiltrados.length === 0) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center', background: '#f8fafc', borderRadius: '10px', border: '1px dashed #cbd5e1', color: '#64748b', fontSize: '13px' }}>
                          No hay Factura, Cédula o Manifiesto adjuntos en este trámite.
                        </div>
                      );
                    }

                    return docsFiltrados.map((arc) => (
                      <div key={arc.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px' }}>
                        <div>
                          <strong style={{ fontSize: '13px', color: '#0f172a', display: 'block' }}>{arc.tipo_documento.toUpperCase().replace('_', ' ')}</strong>
                          <span style={{ fontSize: '11px', color: '#64748b' }}>{arc.nombre_original}</span>
                        </div>
                        <a
                          href={`${API_URL}/uploads/tramites/${arc.nombre_disco}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-secondary"
                          style={{ padding: '6px 12px', fontSize: '12px', textDecoration: 'none', background: '#2563eb', color: '#ffffff', borderRadius: '6px', fontWeight: '700' }}
                        >
                          👁️ Ver
                        </a>
                      </div>
                    ));
                  })()}
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {/* Footer */}
        <div style={{ padding: '16px 24px', background: '#f8fafc', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn-secondary" onClick={onClose} style={{ padding: '8px 20px', borderRadius: '8px', fontWeight: '700', cursor: 'pointer' }}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetalleSoatModal;
